module.exports = __webpack_public_path__ + "assets/6806552247675155d176fc419e9ce893.png";